import { Alert, Collapse } from '@mui/material';

interface PreviewInfoBannerProps {
  open: boolean;
  onClose: () => void;
}

export const PreviewInfoBanner = ({ open, onClose }: PreviewInfoBannerProps) => (
  <Collapse in={open} unmountOnExit>
    <Alert severity="info" variant="outlined" onClose={onClose} sx={{ py: 0.25 }}>
      Revisa las filas marcadas en amarillo o rojo. Nada se importa hasta que confirmes.
    </Alert>
  </Collapse>
);
